// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MansionLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeGoods: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalk: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSpecial: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeOwn: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeNotOwn: cc.Node = null;

    private oriGoodsPos: cc.Vec2 = null;

    private specialGoods: number = 0;

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.MansionLayer, this.node, ()=> {
            this.refreshState();
        });

        this.oriGoodsPos = this.nodeGoods.getPosition();
        this.nodeTalk.active = false;
        this.nodeSpecial.active = false;
        this.nodeGoods.active = false;

        this.refreshState();
        this.refreshBlackShadow();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.MansionLayer);
    }

    refreshBlackShadow() {
        let curTime = data_control.getCurrDateDayString();
        let mansionData = UserDataManage.instance.mansionDataManage.mansionData;
        this.nodeSpecial.active = mansionData.lastBlackShadowTime != curTime;
    }

    refreshState() {
        let gameData = NormalGameManager._instance.getGameData();
        
        this.nodeOwn.active = gameData.bBuyMansion;
        this.nodeNotOwn.active = !gameData.bBuyMansion;
    }

    onClickBuild() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsView.openPopupLayer(
            'prefab/build/MansionsBuildLayer'
            , BUNDLE_SMALL_NAME.mansionBundle
        );
    }

    onClickRoom() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsView.openPopupLayer(
            'prefab/member/MansionsMemberLayer'
            , BUNDLE_SMALL_NAME.mansionBundle
        );
    }

    onClickBalckShadow() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let curTime = data_control.getCurrDateDayString();
        let mansionData = UserDataManage.instance.mansionDataManage.mansionData;
        if (mansionData.lastBlackShadowTime == curTime) {
            return;
        }
        mansionData.lastBlackShadowTime = curTime;
        mansionData.saveLocalData();

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, 'black_shadow_goods_drop');
        if (!info) {
            console.error(`未找到表格数据`);
            return;
        }
        let splits = utilsModel.splitLineFeed(info.value);
        let idx = data_control.randomNumInt(0, splits.length - 1);
        this.specialGoods = Number(splits[idx]);

        let backItem = backPackEventMap()[this.specialGoods];
        let sprGoods = this.nodeGoods.getChildByName('sprGoods').getComponent(cc.Sprite);
        utilsView.loadGoodsSpriteFrame(
            sprGoods
            , backItem.spPath
            , false
        );

        this.nodeGoods.active = true;
        this.nodeGoods.setPosition(this.nodeSpecial.getPosition());
        this.refreshBlackShadow();
        
        let cPosx = (this.nodeGoods.x + this.oriGoodsPos.x)/2;
        let cPosy = this.nodeGoods.y + 500;

        let cPos = cc.v2(cPosx, cPosy);
        cc.tween(this.nodeGoods)
        .bezierTo(0.5, this.nodeGoods.getPosition(), cPos, this.oriGoodsPos)
        .call(()=> {
            this.nodeTalk.active = true;
            cc.tween(this.nodeTalk)
            .delay(2)
            .call(()=> {
                this.nodeTalk.active = false;
            })
            .start();
        })
        .start();
    }

    async onClickGoods() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (!this.nodeGoods.active) {
            return;
        }
        this.nodeGoods.active = false;

        let addGoodsList = {};
        addGoodsList[this.specialGoods] = 1;
        await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        NormalGameManager._instance.onPushGoods(this.specialGoods, 1);
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }
}
